<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <template v-slot:activator="{ on }">
      <v-btn flat @click="dialog = true" color="accent">
        <v-icon class="mr-1" small>mdi-pencil</v-icon>
        Editar Nome do Documento Pré-definido
      </v-btn>
    </template>


    <v-card>
      <v-card-title class="docgo white--text title" primary-title>
        <v-icon color="white" class="pr-4">mdi-file-document-box-plus
        </v-icon>
        <span>Novo documento pré-definido</span>
      </v-card-title>
      <v-card-text>

        <v-form v-model="valid" ref="form">
          <v-text-field label="Nome do documento" v-model="name" :rules="[v => !!v || 'Nome é Obrigatório']" :counter="80"
            required />

          <v-text-field label="Sigla" v-model="abbreviation" :rules="[v => !!v || 'Sigla é Obrigatória']" :counter="8"
            required />


        </v-form>
      </v-card-text>
      <v-card-actions class="justify-space-between">
        <v-btn flat @click="dialog = false" :disabled="!valid">Cancelar
        </v-btn>
        <v-btn color="blue darken-1 white--text" :disabled="!valid" @click="saveChanges()">Continuar
        </v-btn>
      </v-card-actions>
    </v-card>


  </v-dialog>
</template>

<script>
export default {
  name: 'EditAttributesDocumentTypeDialog',
  props: ['documentType'],
  data() {
    return {
      name: '',
      abbreviation: '',
      dialog: false,
      valid: false
    };
  },
  methods: {
    saveChanges() {
      this.$emit('save', {
        name: this.name,
        abbreviation: this.abbreviation
      });
      this.dialog = false
    },
    reloadParams() {
      this.name = this.documentType.name;
      this.abbreviation = this.documentType.abbreviation;
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.reloadParams();
      }
    },
    documentType(newValue) {
      this.reloadParams();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/document_types/EditAttributesDocumentTypeDialog.vue